
define('boxes/helpers/payment-sender-helper',['jquery', 'all/comeon', 'boxes/helpers/box-loading', 'all/paymentServices-toggles'], function($, comeon, boxLoading, paymentServicesToggles) {
    'use strict';

    function checkLimits(amount, paymentMethodId, providerId, url, amountIsVisible) {
        var checkLimitParameterData = {
            am: amount,
            paymentMethodId: paymentMethodId,
            providerId: providerId,
            amountIsVisible: amountIsVisible
        };
        var limitsCheckPromise = comeon.promise.create();
		if(paymentServicesToggles.useNewPaymentFormDataService()){
			// This will be checked by the integration anyway
			var checkLimitResponseData = {'successful' : true};
			limitsCheckPromise.resolve(checkLimitResponseData);
		} else{
			$.post(url, checkLimitParameterData, function (checkLimitResponseData) {
				limitsCheckPromise.resolve(checkLimitResponseData);
			});
		}

        return limitsCheckPromise.promise();
    }

    function verifyAndSendPayment(paymentBox, formTemplate, limitUrl){
        var $amountBox = paymentBox.$box.find('.amount-box');
        var amount = $amountBox.find('input').val();
        var amountIsVisible = $amountBox.is(':visible');
        var paymentMethodId = paymentBox.model.paymentController.selectedFormMethodId;
		if(formTemplate.paymentMethod.paymentType === "deposit") {
			var bonusId = paymentBox.$box.find('.selected-bonus').data('bonus-id');
			if(bonusId) {
				var bonusAddonId = paymentBox.model.bonusData.addonId;
				var bonusAddonChosenOptionId = paymentBox.model.bonusData.addonChosenOptionId;
			}
		}
        var providerId = paymentBox.model.providerId;

        var limitsCheckPromise = checkLimits(amount, paymentMethodId, providerId, limitUrl, amountIsVisible);

        $.when(limitsCheckPromise).then(function(checkLimitResponseData) {
            if(checkLimitResponseData.successful) {
                var parameterData = {
                    utimestamp: new Date().getTime(),
                    am: amount,
                    bid: bonusId,
					baid: bonusAddonId,
					oid: bonusAddonChosenOptionId,
                    paymentMethodId: paymentMethodId
                };

                var formTemplateSelector = formTemplate.getSelectorClass();
                var $formElements = paymentBox.$box.find(formTemplateSelector).find('input, textarea, select');
				var formParameters = {};
				$formElements.serializeArray().map(function(x){formParameters[x.name] = x.value;});
				var allParameters = $.extend(parameterData, formParameters);

                boxLoading.showLoading(paymentBox.$box);

                sendPayment(allParameters, formTemplate, paymentBox);

            } else {
                paymentBox.model.showFailMessage(paymentBox, checkLimitResponseData.errorMessage);
            }
        });
    }

    function sendPayment(allParameters, formTemplate, paymentBox) {

		var parameters;
		var contentType = 'application/json; charset=utf-8';

		if(formTemplate.paymentMethod.executeUrl.indexOf('Integration') === -1){
			parameters = $.param(allParameters);
			contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
		} else{
			parameters = JSON.stringify(allParameters);
		}

		$.ajax ({
			url: formTemplate.paymentMethod.executeUrl,
			type: 'POST',
			data: parameters,
			dataType: 'json',
			contentType: contentType,
			success: function (responseData) {
				if (responseData.successful === true) {
					formTemplate.sendHandler.handleSuccessfulResponse(paymentBox, responseData.sendHandlerData, responseData.accHistRef, responseData.paymentFetchResultFlow);
				} else {
					if (responseData.CODE === 'COOL_OFF') {

					}
					formTemplate.sendHandler.cleanupOnFail();
					boxLoading.removeLoading(paymentBox.$box);
					paymentBox.model.showFailMessage(paymentBox, responseData.errorMessage);
				}
			}
		});
    }

    function createUrlWithParameters(url, parameters){
        var character;
        if(url.indexOf('?') > -1){
            character = '&';
        } else{
            character = '?';
        }

        var urlWithParameters = url + character + $.param(parameters);
        return urlWithParameters;
    }

    var paymentSenderHelper  = {};
    paymentSenderHelper.verifyAndSendPayment = verifyAndSendPayment;
    paymentSenderHelper.createUrlWithParameters = createUrlWithParameters;
    return paymentSenderHelper;
});

